module.exports = __webpack_public_path__ + "img/resultado5.30696e3f.jpg";